import { API_CUSTOMER_PROFILE_URL } from '@/constants/config';
import { fetch } from '@/utils/fetch';

interface CustomerCheckInPayload {
  outletId: string;
  tableNumber: string;
  customerId: string;
}

interface CustomerCheckInResponse {
  success: boolean;
  message?: string;
}

export const customerCheckIn = (payload: CustomerCheckInPayload) =>
  fetch<CustomerCheckInResponse>({
    method: 'POST',
    url: `${API_CUSTOMER_PROFILE_URL}/customer/restaurant/table/check-in`,
    data: payload,
  });
